import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="quiz-choice"
export default class extends Controller {
  static targets = [ "base", "correct", "correctJump", "wrongJump" ]

  changeChoice(event) {
    const target_length = this.correctTargets.length
    const action_count = Number(event.target.value) - target_length
    if(action_count > 0) {
      for (let count = 0; count < action_count; count++) {
        const clone_value = String.fromCharCode(count + target_length + 'A'.charCodeAt())
        const clone_target = this.correctTarget.cloneNode(true)
        const target_input = clone_target.querySelector('input')
        const target_label = clone_target.querySelector('label')
        target_input.value = count + target_length
        target_input.checked = false
        target_input.id = `forms_movie_authorings_quiz_edit_correct_${clone_value.toLowerCase()}`
        target_label.for = `forms_movie_authorings_quiz_edit_correct_${clone_value.toLowerCase()}`
        target_label.textContent = clone_value
        this.baseTarget.append(clone_target)
      }
    } else if(action_count < 0) {
      for (let count = 0; count < action_count * -1; count++) {
        const remove_target = this.correctTargets[target_length - 1 - count]
        if(remove_target.querySelector('input').checked) {
          remove_target.checked = false
          this.correctTarget.querySelector('input').checked = true
         }
        remove_target.remove()
      }
    }
  }

  correctTextEdit(event) {
    if(!event.target.value) {
      this.correctJumpTarget.disabled = true
    } else {
      this.correctJumpTarget.disabled = false
    }
  }

  wrongTextEdit(event) {
    if(!event.target.value) {
      this.wrongJumpTarget.disabled = true
    } else {
      this.wrongJumpTarget.disabled = false
    }
  }
}
